import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntConfirm } from "src/app/common/dialog";
import {
  TaskExecutionPlan,
  TasksService,
  TaskType
} from "src/app/services/tasks.service";
import { sntTranslate } from "src/app/support/translate";

@Injectable()
export class PWAService {
  private readonly tasksService = inject(TasksService);

  private deferredPrompt: any | undefined;

  listenEvent(): void {
    window.addEventListener("beforeinstallprompt", (deferredPrompt) => {
      deferredPrompt.preventDefault();
      this.deferredPrompt = deferredPrompt;
    });
  }

  start(): void {
    if (this.deferredPrompt) {
      this.scheduleInstall();
    } else {
      window.addEventListener("beforeinstallprompt", (deferredPrompt) => {
        deferredPrompt.preventDefault();
        this.deferredPrompt = deferredPrompt;

        this.scheduleInstall();
      });
    }
  }

  private scheduleInstall(): void {
    this.tasksService.schedule({
      fn: () => {
        sntConfirm(
          sntTranslate(marker("Snoots PMS")),
          sntTranslate(
            marker(
              "E' possibile installare Snoots PMS come applicazione, Snoots consiglia questa procedura per una migliore esperienza d'uso. Se vuoi procedere clicca su \"Procedi\" e successivamente conferma l'installazione."
            )
          ),
          {
            confirmText: sntTranslate(marker("Procedi")),
            cancelText: sntTranslate(marker("Annulla"))
          }
        ).then((result) => {
          if (result) {
            this.deferredPrompt?.prompt();
          }
        });
      },
      plan: TaskExecutionPlan.WHEN_STABLE,
      type: TaskType.RUN_ONCE
    });
  }
}
